const translations = {
  en: {
    name: 'English',
    load: () => import('./en.json'),
  },
  cz: {
    name: 'Čeština',
    load: () => import('./cz.json'),
  },
  es: {
    name: 'Español',
    load: () => import('./es.json'),
  },
  ru: {
    name: 'Русский',
    load: () => import('./ru.json'),
  },
  fi: {
    name: 'Suomi',
    load: () => import('./fi.json'),
  },
  nl: {
    name: 'Nederlands',
    load: () => import('./nl.json'),
  },
  ua: {
    name: 'Українська',
    load: () => import('./ua.json'),
  },
  da: {
    name: 'Dansk',
    load: () => import('./da.json'),
  },
  fr: {
    name: 'Français',
    load: () => import('./fr.json'),
  },
  hu: {
    name: 'Magyar',
    load: () => import('./hu.json'),
  },
  it: {
    name: 'Italiano',
    load: () => import('./it.json'),
  },
  pl: {
    name: 'Polski',
    load: () => import('./pl.json'),
  },
  cn: {
    name: '中文 (中国)',
    load: () => import('./cn.json'),
  },
  de: {
    name: 'Deutsch',
    load: () => import('./de.json'),
  },
  ro: {
    name: 'Română',
    load: () => import('./ro.json'),
  },
  bg: {
    name: 'български',
    load: () => import('./bg.json'),
  },
  se: {
    name: 'Svenska',
    load: () => import('./se.json'),
  },
  gr: {
    name: 'Ελληνικά',
    load: () => import('./gr.json'),
  },
  tr: {
    name: 'Türkçe',
    load: () => import('./tr.json'),
  },
};

// Sort translations alphabetically by key
const sortedTranslations = {};
Object.keys(translations).sort().forEach((v) => {
  sortedTranslations[v] = translations[v];
});

export default sortedTranslations;
